export default "__VITE_ASSET__BFkVhFUE__"